import "./PricingPage.css"; 

// Define an array of pricing plans, each with details used in UI
const plans = [
  {
    title: "Financial Building (FB)", 
    subtitle: "Get started by creating your Business Financials.",
    price: "$10.00 USD/user/month",
    note: "(billed annually)", 
    cta: "Sign-up",
    features: [ 
      "Build your Business Financials",
      "Investment Sizing",
      "Get all financial ratios and stats.",
      "Dynamic Income and Cost allocation",
      "Full ARR (ARS) schedule",
      "Interactively adjust or edit your financials."
    ],
    mostPopular: false
  },
  {
    title: "Critical Financial Insight (CFI)",
    subtitle: "You already have your Financial Projection? Add Critical Insight.",
    price: "$18.33 USD/user/month",
    note: "(billed annually)",
    cta: "Try for free",
    features: [
      "Manage multiple entities or projections.",
      "Equity Management",
      "Valuations",
      "Cap Tables",
      "Price Investments via IRR or ROI.",
      "Price Equity and Partners"
    ],
    mostPopular: false
  },
  {
    title: "Premium Strategic Business Building (PSBB)",
    subtitle: "Get complete control on your Business Financials.",
    price: "$25.50 USD/user/month",
    note: "(billed annually)",
    cta: "Let's Talk",
    features: [
      "Includes the products FB and CFI.",
      "Dashboard “MyVentureCFO”",
      "Create Financials based on key metrics and ratios.",
      "Easily adjust and update your financials.",
      "Multi-Product Analytics and valuations.",
      "Continually update your Business Strategy and projections"
    ],
    mostPopular: true // Optional property to highlight this plan
  }
];

// Reusable component to render a single pricing card
const PricingCard = ({ title, subtitle, price, note, cta, features, mostPopular }) => (
  <div className="card"> 
    {mostPopular && 
      <div className="card-header">
        <span className="card-popular">Most Popular</span>
      </div>
    }
    <h2 className="card-title">{title}</h2> 
    <p className="card-subtitle">{subtitle}</p>
    <p className="card-price">{price}</p>
    <p className="card-note">{note}</p>
    <button className="card-cta">{cta}</button> 
    <ul className="card-features"> 
      {features.map((feature, idx) => (
        <li key={idx}>{feature}</li> 
      ))}
    </ul>
  </div>
);

// Main component to render the full pricing page
const PricingPage = () => {
  return (
    <div className="pricing-page">
      <div className="pricing-banner">
        <h1 className="pricing-header">Find the Perfect Plan for You</h1>
        <p className="pricing-subtitle">Choose a subscription that scales with your business.</p>
      </div>
      <div className="pricing-container"> 
        {plans.map((plan, idx) => (
          <PricingCard key={idx} {...plan} />
        ))}
      </div>
    </div>
  );
};

export default PricingPage; 